import { createSlice } from "@reduxjs/toolkit";

import { InputType } from "../../components/common";
import { paymentRequestApi } from "../services/paymentRequestLinks";
import type { RootState } from "../../store";
import type { PaymentRequestLinks } from "../../types/PaymentRequestLinkTypes";

type PaymentRequestLinkState = {
  selected: PaymentRequestLinks | undefined;
  selectedCalculatorInput: InputType | undefined;
  step: number;
};

const initialState: PaymentRequestLinkState = {
  selected: undefined,
  selectedCalculatorInput: undefined,
  step: 0,
};

const paymentRequestLinkSlice = createSlice({
  name: "paymentRequestLinks",
  initialState,
  reducers: {
    setCalculatorInput: (state, action) => {
      state.selectedCalculatorInput = action.payload;
    },
    nextStep: (state) => {
      state.step = state.step + 1;
    },
    prevStep: (state) => {
      state.step = state.step - 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        paymentRequestApi.endpoints.getPaymentRequestLink.matchFulfilled,
        (state, { payload }) => {
          state.selected = payload;
        }
      )
      .addMatcher(
        paymentRequestApi.endpoints.getPaymentRequestLinkPublic.matchFulfilled,
        (state, { payload }) => {
          state.selected = payload;
        }
      );
  },
});

export const { setCalculatorInput, nextStep, prevStep } =
  paymentRequestLinkSlice.actions;

export default paymentRequestLinkSlice.reducer;

export const selectPaymentRequestLinks = (state: RootState) =>
  state.paymentRequestLinks.selected;

export const selectSelectedCalculatorInput = (state: RootState) =>
  state.paymentRequestLinks.selectedCalculatorInput;

export const selectStep = (state: RootState) => state.paymentRequestLinks.step;
